export default __webpack_public_path__ + "static/33-across-569a81c7a0cb013eb9937f3cbd504e18.png";